module.exports = __webpack_public_path__ + "assets/3-Sales-Recruitment-Agency.4c58423f.png";